import { RegionProps } from 'types'
export const getRegionName = (region: RegionProps): string => region?.HOLIDAY_REGION ?? ''
